import type { KnowledgeItem } from '../types';

const createdAt = '2026-09-22T00:00:00.000Z';

function poem(
  id: string,
  title: string,
  dynasty: string,
  author: string,
  content: string
): KnowledgeItem {
  return {
    id: `primary-poem-${id}`,
    type: 'poem',
    title,
    content,
    dynasty,
    author,
    source: '小学生必背古诗词75首',
    createdAt
  };
}

export const primarySchoolPoemKnowledge: KnowledgeItem[] = [
  poem('001', '江南', '汉', '汉乐府', '江南可采莲，莲叶何田田。\n鱼戏莲叶间。\n鱼戏莲叶东，鱼戏莲叶西，\n鱼戏莲叶南，鱼戏莲叶北。'),
  poem('002', '长歌行', '汉', '汉乐府', '青青园中葵，朝露待日晞。\n阳春布德泽，万物生光辉。\n常恐秋节至，焜黄华叶衰。\n百川东到海，何时复西归？\n少壮不努力，老大徒伤悲！'),
  poem('003', '敕勒歌', '南北朝', '北朝民歌', '敕勒川，阴山下。\n天似穹庐，笼盖四野。\n天苍苍，野茫茫，\n风吹草低见牛羊。'),
  poem('004', '咏鹅', '唐', '骆宾王', '鹅，鹅，鹅，\n曲项向天歌。\n白毛浮绿水，\n红掌拨清波。'),
  poem('005', '风', '唐', '李峤', '解落三秋叶，能开二月花。\n过江千尺浪，入竹万竿斜。'),
  poem('006', '咏柳', '唐', '贺知章', '碧玉妆成一树高，万条垂下绿丝绦。\n不知细叶谁裁出，二月春风似剪刀。'),
  poem('007', '回乡偶书', '唐', '贺知章', '少小离家老大回，乡音无改鬓毛衰。\n儿童相见不相识，笑问客从何处来。'),
  poem('008', '凉州词', '唐', '王之涣', '黄河远上白云间，一片孤城万仞山。\n羌笛何须怨杨柳，春风不度玉门关。'),
  poem('009', '登鹳雀楼', '唐', '王之涣', '白日依山尽，黄河入海流。\n欲穷千里目，更上一层楼。'),
  poem('010', '春晓', '唐', '孟浩然', '春眠不觉晓，处处闻啼鸟。\n夜来风雨声，花落知多少。'),
  poem('011', '凉州词', '唐', '王翰', '葡萄美酒夜光杯，欲饮琵琶马上催。\n醉卧沙场君莫笑，古来征战几人回？'),
  poem('012', '出塞', '唐', '王昌龄', '秦时明月汉时关，万里长征人未还。\n但使龙城飞将在，不教胡马度阴山。'),
  poem('013', '芙蓉楼送辛渐', '唐', '王昌龄', '寒雨连江夜入吴，平明送客楚山孤。\n洛阳亲友如相问，一片冰心在玉壶。'),
  poem('014', '鹿柴', '唐', '王维', '空山不见人，但闻人语响。\n返景入深林，复照青苔上。'),
  poem('015', '送元二使安西', '唐', '王维', '渭城朝雨浥轻尘，客舍青青柳色新。\n劝君更尽一杯酒，西出阳关无故人。'),
  poem('016', '九月九日忆山东兄弟', '唐', '王维', '独在异乡为异客，每逢佳节倍思亲。\n遥知兄弟登高处，遍插茱萸少一人。'),
  poem('017', '静夜思', '唐', '李白', '床前明月光，疑是地上霜。\n举头望明月，低头思故乡。'),
  poem('018', '古朗月行（节选）', '唐', '李白', '小时不识月，呼作白玉盘。\n又疑瑶台镜，飞在青云端。'),
  poem('019', '望庐山瀑布', '唐', '李白', '日照香炉生紫烟，遥看瀑布挂前川。\n飞流直下三千尺，疑是银河落九天。'),
  poem('020', '赠汪伦', '唐', '李白', '李白乘舟将欲行，忽闻岸上踏歌声。\n桃花潭水深千尺，不及汪伦送我情。'),
  poem('021', '黄鹤楼送孟浩然之广陵', '唐', '李白', '故人西辞黄鹤楼，烟花三月下扬州。\n孤帆远影碧空尽，唯见长江天际流。'),
  poem('022', '早发白帝城', '唐', '李白', '朝辞白帝彩云间，千里江陵一日还。\n两岸猿声啼不住，轻舟已过万重山。'),
  poem('023', '望天门山', '唐', '李白', '天门中断楚江开，碧水东流至此回。\n两岸青山相对出，孤帆一片日边来。'),
  poem('024', '别董大', '唐', '高适', '千里黄云白日曛，北风吹雁雪纷纷。\n莫愁前路无知己，天下谁人不识君？'),
  poem('025', '绝句', '唐', '杜甫', '两个黄鹂鸣翠柳，一行白鹭上青天。\n窗含西岭千秋雪，门泊东吴万里船。'),
  poem('026', '春夜喜雨', '唐', '杜甫', '好雨知时节，当春乃发生。\n随风潜入夜，润物细无声。\n野径云俱黑，江船火独明。\n晓看红湿处，花重锦官城。'),
  poem('027', '绝句', '唐', '杜甫', '迟日江山丽，春风花草香。\n泥融飞燕子，沙暖睡鸳鸯。'),
  poem('028', '江畔独步寻花', '唐', '杜甫', '黄四娘家花满蹊，千朵万朵压枝低。\n留连戏蝶时时舞，自在娇莺恰恰啼。'),
  poem('029', '游子吟', '唐', '孟郊', '慈母手中线，游子身上衣。\n临行密密缝，意恐迟迟归。\n谁言寸草心，报得三春晖。'),
  poem('030', '江雪', '唐', '柳宗元', '千山鸟飞绝，万径人踪灭。\n孤舟蓑笠翁，独钓寒江雪。'),
  poem('031', '寻隐者不遇', '唐', '贾岛', '松下问童子，言师采药去。\n只在此山中，云深不知处。'),
  poem('032', '枫桥夜泊', '唐', '张继', '月落乌啼霜满天，江枫渔火对愁眠。\n姑苏城外寒山寺，夜半钟声到客船。'),
  poem('033', '渔歌子', '唐', '张志和', '西塞山前白鹭飞，桃花流水鳜鱼肥。\n青箬笠，绿蓑衣，斜风细雨不须归。'),
  poem('034', '塞下曲', '唐', '卢纶', '月黑雁飞高，单于夜遁逃。\n欲将轻骑逐，大雪满弓刀。'),
  poem('035', '望洞庭', '唐', '刘禹锡', '湖光秋月两相和，潭面无风镜未磨。\n遥望洞庭山水翠，白银盘里一青螺。'),
  poem('036', '浪淘沙', '唐', '刘禹锡', '九曲黄河万里沙，浪淘风簸自天涯。\n如今直上银河去，同到牵牛织女家。'),
  poem('037', '赋得古原草送别', '唐', '白居易', '离离原上草，一岁一枯荣。\n野火烧不尽，春风吹又生。\n远芳侵古道，晴翠接荒城。\n又送王孙去，萋萋满别情。'),
  poem('038', '池上', '唐', '白居易', '小娃撑小艇，偷采白莲回。\n不解藏踪迹，浮萍一道开。'),
  poem('039', '忆江南', '唐', '白居易', '江南好，风景旧曾谙。\n日出江花红胜火，春来江水绿如蓝。\n能不忆江南？'),
  poem('040', '悯农（其一）', '唐', '李绅', '春种一粒粟，秋收万颗子。\n四海无闲田，农夫犹饿死。'),
  poem('041', '悯农（其二）', '唐', '李绅', '锄禾日当午，汗滴禾下土。\n谁知盘中餐，粒粒皆辛苦。'),
  poem('042', '山行', '唐', '杜牧', '远上寒山石径斜，白云生处有人家。\n停车坐爱枫林晚，霜叶红于二月花。'),
  poem('043', '清明', '唐', '杜牧', '清明时节雨纷纷，路上行人欲断魂。\n借问酒家何处有？牧童遥指杏花村。'),
  poem('044', '江南春', '唐', '杜牧', '千里莺啼绿映红，水村山郭酒旗风。\n南朝四百八十寺，多少楼台烟雨中。'),
  poem('045', '蜂', '唐', '罗隐', '不论平地与山尖，无限风光尽被占。\n采得百花成蜜后，为谁辛苦为谁甜？'),
  poem('046', '江上渔者', '宋', '范仲淹', '江上往来人，但爱鲈鱼美。\n君看一叶舟，出没风波里。'),
  poem('047', '元日', '宋', '王安石', '爆竹声中一岁除，春风送暖入屠苏。\n千门万户曈曈日，总把新桃换旧符。'),
  poem('048', '泊船瓜洲', '宋', '王安石', '京口瓜洲一水间，钟山只隔数重山。\n春风又绿江南岸，明月何时照我还？'),
  poem('049', '书湖阴先生壁', '宋', '王安石', '茅檐长扫净无苔，花木成畦手自栽。\n一水护田将绿绕，两山排闼送青来。'),
  poem('050', '六月二十七日望湖楼醉书', '宋', '苏轼', '黑云翻墨未遮山，白雨跳珠乱入船。\n卷地风来忽吹散，望湖楼下水如天。'),
  poem('051', '饮湖上初晴后雨', '宋', '苏轼', '水光潋滟晴方好，山色空蒙雨亦奇。\n欲把西湖比西子，淡妆浓抹总相宜。'),
  poem('052', '惠崇春江晚景', '宋', '苏轼', '竹外桃花三两枝，春江水暖鸭先知。\n蒌蒿满地芦芽短，正是河豚欲上时。'),
  poem('053', '题西林壁', '宋', '苏轼', '横看成岭侧成峰，远近高低各不同。\n不识庐山真面目，只缘身在此山中。'),
  poem('054', '夏日绝句', '宋', '李清照', '生当作人杰，死亦为鬼雄。\n至今思项羽，不肯过江东。'),
  poem('055', '示儿', '宋', '陆游', '死去元知万事空，但悲不见九州同。\n王师北定中原日，家祭无忘告乃翁。'),
  poem('056', '秋夜将晓出篱门迎凉有感', '宋', '陆游', '三万里河东入海，五千仞岳上摩天。\n遗民泪尽胡尘里，南望王师又一年。'),
  poem('057', '四时田园杂兴', '宋', '范成大', '梅子金黄杏子肥，麦花雪白菜花稀。\n日长篱落无人过，惟有蜻蜓蛱蝶飞。'),
  poem('058', '小池', '宋', '杨万里', '泉眼无声惜细流，树阴照水爱晴柔。\n小荷才露尖尖角，早有蜻蜓立上头。'),
  poem('059', '晓出净慈寺送林子方', '宋', '杨万里', '毕竟西湖六月中，风光不与四时同。\n接天莲叶无穷碧，映日荷花别样红。'),
  poem('060', '春日', '宋', '朱熹', '胜日寻芳泗水滨，无边光景一时新。\n等闲识得东风面，万紫千红总是春。'),
  poem('061', '题临安邸', '宋', '林升', '山外青山楼外楼，西湖歌舞几时休？\n暖风熏得游人醉，直把杭州作汴州。'),
  poem('062', '游园不值', '宋', '叶绍翁', '应怜屐齿印苍苔，小扣柴扉久不开。\n春色满园关不住，一枝红杏出墙来。'),
  poem('063', '乡村四月', '宋', '翁卷', '绿遍山原白满川，子规声里雨如烟。\n乡村四月闲人少，才了蚕桑又插田。'),
  poem('064', '村居', '清', '高鼎', '草长莺飞二月天，拂堤杨柳醉春烟。\n儿童散学归来早，忙趁东风放纸鸢。'),
  poem('065', '墨梅', '元', '王冕', '我家洗砚池头树，朵朵花开淡墨痕。\n不要人夸好颜色，只留清气满乾坤。'),
  poem('066', '石灰吟', '明', '于谦', '千锤万凿出深山，烈火焚烧若等闲。\n粉骨碎身浑不怕，要留清白在人间。'),
  poem('067', '竹石', '清', '郑燮', '咬定青山不放松，立根原在破岩中。\n千磨万击还坚劲，任尔东西南北风。'),
  poem('068', '所见', '清', '袁枚', '牧童骑黄牛，歌声振林樾。\n意欲捕鸣蝉，忽然闭口立。'),
  poem('069', '己亥杂诗', '清', '龚自珍', '九州生气恃风雷，万马齐喑究可哀。\n我劝天公重抖擞，不拘一格降人才。'),
  poem('070', '七步诗', '三国', '曹植', '煮豆持作羹，漉菽以为汁。\n萁在釜下燃，豆在釜中泣。\n本自同根生，相煎何太急？'),
  poem('071', '鸟鸣涧', '唐', '王维', '人闲桂花落，夜静春山空。\n月出惊山鸟，时鸣春涧中。'),
  poem('072', '秋浦歌', '唐', '李白', '白发三千丈，缘愁似个长。\n不知明镜里，何处得秋霜。'),
  poem('073', '独坐敬亭山', '唐', '李白', '众鸟高飞尽，孤云独去闲。\n相看两不厌，只有敬亭山。'),
  poem('074', '竹里馆', '唐', '王维', '独坐幽篁里，弹琴复长啸。\n深林人不知，明月来相照。'),
  poem('075', '夜宿山寺', '唐', '李白', '危楼高百尺，手可摘星辰。\n不敢高声语，恐惊天上人。')
];
